<template>
	<div>
		<b-breadcrumb>Admin</b-breadcrumb>
		<b-alert :show="!!error" variant="danger">{{error&&(error.error||error.toString())}}</b-alert>
		<b-spinner v-show="loading>0" small label="Spinning" class="mr-3"></b-spinner><br />
		<b-form-row>
			<b-col>
				<b-button @click="getHeapStatistics()">Get heap statistics</b-button><br />
				<pre v-if="statistics">{{statistics}}</pre>
			</b-col>
			<b-col>
				<b-button @click="generateHeapSnapshot()" variant="danger">Generate heap snapshot</b-button>
				<b-input v-if="!!snapshotResult" v-model="snapshotResult.filename" readonly/>
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
export default {
	data() { return {
		statistics: null,
		snapshotResult: null,
		error: null,
		loading: 0,
		total: 0,
	}},
	methods: {
		async getHeapStatistics() {
			try {
				this.statistics = null;
				this.error = null;
				this.loading++;
				this.statistics = await this.$api.get('heapStatistics');
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
		async generateHeapSnapshot() {
			try {
				this.snapshotPath = null;
				this.error = null;
				this.loading++;
				this.snapshotResult = await this.$api.post('heapSnapshot');
			} catch(e) {
				this.error = e;
			} finally {
				this.loading--;
			}
		},
	},
};
</script>
